/* PointHome — Kategori kartinda olcu cipleri (MK, 08.09.2026)
   Model: gowoll.de — cip fiyati gunceller ve karti o varyanta baglar. SEPETE EKLEMEZ.

   ⚠️ OLCULEN DOM GERCEKLERI (canli tema, 08.09.2026):
   · Guncel fiyat DOM'da IKI KEZ basiliyor; hangisinin gorunecegine CSS karar veriyor:
       .f-price__regular .f-price-item--regular   (indirim yokken gorunur)
       .f-price__sale    .f-price-item--sale      (indirimliyken gorunur)
     IKISI BIRDEN guncellenmeli.
   · Ustu cizili fiyat `--sale` DEGIL: .f-price__sale .f-price-item--regular s
   · Varyantli uruncede tema fiyata "Von " onegi koyuyor → cip secilince kaldirilir.
   · Indirim rozeti kartin GORSEL kisminda: .product-card__badge .f-badge--sale ("Rabatt").
   · Kart linklerinde ?variant= yok — ucu de elle guncelleniyor.
   · .f-price sinif dizesinde satir sonlari var → classList kullan, string esitligi degil.

   gowoll'deki bug BURADA YOK: ilk degerler kart uzerinde saklaniyor, ayni cipe
   ikinci tiklamada tam olarak eski haline donuluyor. */

(function () {
  if (window.__phoOlculer) return;
  window.__phoOlculer = 1;

  var SEC = {
    kart:    '.product-card',
    fiyatReg: '.f-price__regular .f-price-item--regular',
    fiyatSale: '.f-price__sale .f-price-item--sale',
    fiyatEski: '.f-price__sale .f-price-item--regular s',
    rozet:   '.product-card__badge .f-badge--sale'
  };

  function veri(kok) {
    var el = kok.querySelector('[data-pho-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Ilk (secim oncesi) degerleri bir kez sakla — geri donus icin. */
  function ilkDegerler(kart) {
    if (kart.__pho0) return kart.__pho0;
    var reg   = kart.querySelector(SEC.fiyatReg);
    var sale  = kart.querySelector(SEC.fiyatSale);
    var eski  = kart.querySelector(SEC.fiyatEski);
    var rozet = kart.querySelector(SEC.rozet);
    kart.__pho0 = {
      reg:   reg   ? reg.textContent   : null,
      sale:  sale  ? sale.textContent  : null,
      eski:  eski  ? eski.textContent  : null,
      rozet: rozet ? rozet.textContent : null,
      linkler: linkler(kart).map(function (a) { return a.getAttribute('href'); })
    };
    return kart.__pho0;
  }

  function linkler(kart) {
    var out = [];
    kart.querySelectorAll('a[href]').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      /* Yalniz bu urunun sayfasina giden linkler; "+N" rozeti de urune gidiyor ama
         onu da guncellemek dogru (secili olcuyle acilsin). */
      if (h.indexOf('/products/') !== -1) out.push(a);
    });
    return out;
  }

  function yaz(el, metin) {
    if (el && metin != null) el.textContent = metin;
  }

  function linkYaz(kart, varyantId) {
    linkler(kart).forEach(function (a) {
      var h = a.getAttribute('href') || '';
      var temiz = h.split('?')[0];
      a.setAttribute('href', varyantId ? (temiz + '?variant=' + varyantId) : temiz);
    });
  }

  function linkGeri(kart, ilk) {
    var ls = linkler(kart);
    for (var i = 0; i < ls.length; i++) {
      if (ilk.linkler[i] != null) ls[i].setAttribute('href', ilk.linkler[i]);
    }
  }

  function uygula(kart, kayit) {
    var ilk = ilkDegerler(kart);

    /* Guncel fiyat iki yerde de yazilir; "Von " onegi kalkar. */
    yaz(kart.querySelector(SEC.fiyatReg), kayit.p);
    yaz(kart.querySelector(SEC.fiyatSale), kayit.p);

    /* Ustu cizili: bu olcunun compare degeri yoksa bosalt. */
    var eski = kart.querySelector(SEC.fiyatEski);
    if (eski) eski.textContent = kayit.c || '';

    /* Rozet: bu olcuye ait indirim yuzdesi. Indirim yoksa ilk metne don. */
    var rozet = kart.querySelector(SEC.rozet);
    if (rozet) rozet.textContent = kayit.d > 0 ? ('-' + kayit.d + '%') : (ilk.rozet || '');

    linkYaz(kart, kayit.v);
  }

  function sifirla(kart) {
    var ilk = kart.__pho0;
    if (!ilk) return;
    yaz(kart.querySelector(SEC.fiyatReg), ilk.reg);
    yaz(kart.querySelector(SEC.fiyatSale), ilk.sale);
    var eski = kart.querySelector(SEC.fiyatEski);
    if (eski && ilk.eski != null) eski.textContent = ilk.eski;
    var rozet = kart.querySelector(SEC.rozet);
    if (rozet && ilk.rozet != null) rozet.textContent = ilk.rozet;
    linkGeri(kart, ilk);
  }

  /* Olay delegasyonu: filtreleme/sayfalama sonrasi gelen kartlar da calisir. */
  document.addEventListener('click', function (e) {
    var cip = e.target.closest ? e.target.closest('[data-pho-cip]') : null;
    if (!cip) return;

    var kok = cip.closest('[data-pho]');
    var kart = cip.closest(SEC.kart);
    if (!kok || !kart) return;

    e.preventDefault();
    e.stopPropagation();

    var secili = cip.classList.contains('is-secili');

    kok.querySelectorAll('[data-pho-cip]').forEach(function (b) {
      b.classList.remove('is-secili');
      b.setAttribute('aria-pressed', 'false');
    });

    if (secili) {
      /* Ayni cipe ikinci tiklama → secimi kaldir, ILK haline don. */
      sifirla(kart);
      return;
    }

    var liste = veri(kok);
    if (!liste) return;

    var deger = cip.getAttribute('data-pho-deger');
    var kayit = null;
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].s === deger) { kayit = liste[i]; break; }
    }
    if (!kayit) return;

    ilkDegerler(kart);
    cip.classList.add('is-secili');
    cip.setAttribute('aria-pressed', 'true');
    uygula(kart, kayit);
  }, false);
})();
